import { useEffect } from 'react';

import google from 'lib/AnalyticsGDM/services/google';

const useLiveChat = ({ enabled }) => {
  useEffect(() => {
    if (!enabled) {
      return () => {};
    }
    google.sendEvent({ event: 'ActivateLiveChat' });
  }, [enabled]);
};

export default useLiveChat;
